import React from "react";
import Card from "components/card";
import {
    LuMessageSquare,
    LuEye,
} from "react-icons/lu"
import AccessButton from "components/button/accessbutton";
import { CATEGORY_ICONS } from "variables/constants"

const TicketCard = (props) => {
    const ticket = { ...props };
    const Icon = CATEGORY_ICONS[ticket?.ticket_category];

    return (
        <div className="space-y-4">
            <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 
                            hover:border-blue-300 hover:shadow-lg transition-all overflow-hidden"
            >
                <div className="pb-6 p-4">
                    <div className="flex items-start gap-4">
                        <div className="p-3 rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md">
                            <Icon className="w-5 h-5" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-start justify-between mb-2">
                                <div>
                                    <h4 className="font-semibold text-[14px] mb-1">
                                        {ticket?.tic_title}
                                    </h4>
                                    <p className="text-[11px] text-slate-600 ">
                                        {ticket?.tic_code}  • Submitted by {ticket?.submitted_by}
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className={`status-indicator ${ticket?.ticket_priority.toLowerCase()} text-[11px]`}>
                                        {ticket?.ticket_priority}
                                    </span>
                                    <span className={`status-indicator ${ticket?.ticket_status.toLowerCase().replace(/\s+/g, "-")} text-[11px]`}>
                                        {ticket?.ticket_status}
                                    </span>
                                </div>
                            </div>
                            <p className="text-[12px] text-slate-600 line-clamp-2 mb-3">
                                {ticket?.tic_description}
                            </p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4 text-[11px] text-slate-600">
                                    <span>{ticket?.ticket_category}</span>
                                    <span>•</span>
                                    <span className="flex items-center gap-1">
                                        <LuMessageSquare className="w-3 h-3" />
                                        {ticket?.replies_count} replies
                                    </span>
                                    <span>•</span>
                                    <span>Updated {ticket?.update}</span>
                                </div>
                                <AccessButton
                                    label="View"
                                    baseRoute={`/console/it-support`}
                                    recordId={ticket?.tic_id}
                                    iconStart={<LuEye className="w-3 h-3 -mr-2" />}
                                    btnClass="btn-view"
                                    state={{ ticket }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
};
export default TicketCard;